import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ActivityCodeForm from "@components/forms/ActivityCodeForm";
import { useAdminContext } from "@/hooks/useAdminContext";

const ActivityCodeAddEdit = () => {
  const params = useParams()
  const { id: activityCodeId } = params;
  const { adminTenantId, isAdminMode, adminQuerySuffix } = useAdminContext();

  const backUrl = `/user/economy-activities${adminQuerySuffix}`;
  const saveRedirectUrl = backUrl;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!activityCodeId ? 'Agregar' : 'Editar'} Actividad Economica`}
      backUrl={backUrl}
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "activityCodeForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <ActivityCodeForm
        formId="activityCodeForm"
        id={activityCodeId}
        ownerTenantId={isAdminMode ? adminTenantId! : undefined}
        saveRedirectUrl={saveRedirectUrl}
      />

    </PageContainer>
  );
}

export default ActivityCodeAddEdit;
